import React from 'react'
import styled from '@emotion/styled'

export interface SelectPrefixProps {
  prefixicon: React.ReactNode
  children: React.ReactNode
  style?: React.CSSProperties
}

export const SelectPrefixWrapper = (props: SelectPrefixProps) => (
  <Wrapper {...props}>
    {props.children}
    <div className='-icon'>{props.prefixicon}</div>
  </Wrapper>
)

//* Usage Guide:
//* Use this component to wrap an ANTD Select Component
//* This component requires a prefixIcon prop(SVG)

//* Recommendations:
//* Add a custom suffixIcon into ANTD's Select component

const Wrapper = styled.div`
  position: relative;

  display: flex;

  > .ant-select {
    max-width: 240px;

    color: #4a4a68;
    font-size: 14px;
    font-weight: 400;
  }

  > .ant-select.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector {
    width: inherit;
    padding-left: 48px;
    padding-right: 32px;
  }

  > .-icon {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 0;

    pointer-events: none;
  }

  > .-icon::after {
    position: absolute;
    right: 0;
    top: 50%;

    content: '';
    width: 1px;
    height: 80%;
    background-color: #e7e5e9;

    transform: translateY(-50%);
  }

  > .-icon svg {
    width: 18px;
    height: 18px;
  }

  > .-icon svg path {
    fill: #8c8ca1;
  }
`
